import {ChevronIcon} from '../../icons/ChevronIcon';

import React, {useCallback, useEffect, useState} from 'react';

const ImgSelect= ({name, items, callBack, defaultValue}) => {
    const [options, setoptions] = useState([]);
    const [selected, setselected] = useState();
    const [openDrop, setopenDrop] = useState(false);

    const toggleDrop = useCallback(() => setopenDrop(!openDrop), [openDrop]);

    const changeSelect = useCallback(
        (value) => (
            e,
        ) => {
            !!e && e.preventDefault();
            if (value) {
                setselected(value);
                const valToSend = {[name]: value.val};
                callBack(valToSend);
                toggleDrop();
            }
            return;
        },
        [callBack, name, toggleDrop],
    );


    useEffect(() => {
        const optionsRes = items.enum.reduce(
            (res, elem, idx) => [...res, {val: elem, desc: items.enumDesc[idx]}],
            [],
        );
        setoptions(optionsRes);
    }, [items]);

    useEffect(() => {
        if (options && defaultValue) {
            const selectedDef = options.find((elem) => elem.val === defaultValue);
            !!selectedDef && setselected(selectedDef);
        }
    }, [options, defaultValue]);

    return (
        <div className="image-select-container">
            {selected && (
                <div className={`img-selected ${openDrop ? 'hide' : ''}`} onClick={toggleDrop}>
                    <img alt="" src={selected.desc} />
                </div>
            )}
            {options && openDrop && (
                <div className="image-drop-down">
                    {options.map(
                        (elem, idx) =>
                            elem && (
                                <div className="img-select-option" key={idx}>
                                    <img onClick={changeSelect(elem)} alt="" src={elem.desc} />
                                </div>
                            ),
                    )}
                </div>
            )}
            <div className="child">
                <ChevronIcon />
            </div>
        </div>
    );
};
export default ImgSelect;
